import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import OnboardingPage from "@/pages/OnboardingPage";
import Dashboard from "@/pages/Dashboard";
import ChatPage from "@/pages/ChatPage";
import BudgetPage from "@/pages/BudgetPage";
import GoalsPage from "@/pages/GoalsPage";
import InvestPage from "@/pages/InvestPage";
import EarnPage from "@/pages/EarnPage";
import SettingsPage from "@/pages/SettingsPage";
import ProfilePage from "@/pages/ProfilePage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ReferralPage from "@/pages/ReferralPage";
import BankConnectionPage from "@/pages/BankConnectionPage";
import BudgetLimitsPage from "@/pages/BudgetLimitsPage";
import BillRemindersPage from "@/pages/BillRemindersPage";
import NotificationSettingsPage from "@/pages/NotificationSettingsPage";
import CardLinkingPage from "@/pages/CardLinkingPage";
import ProjectionPage from "@/pages/ProjectionPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceType" element={<ServiceDetailPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/budget" element={<BudgetPage />} />
            <Route path="/goals" element={<GoalsPage />} />
            <Route path="/invest" element={<InvestPage />} />
            <Route path="/earn" element={<EarnPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/referral" element={<ReferralPage />} />
            <Route path="/bank-connection" element={<BankConnectionPage />} />
            <Route path="/budget-limits" element={<BudgetLimitsPage />} />
            <Route path="/bills" element={<BillRemindersPage />} />
            <Route path="/notifications" element={<NotificationSettingsPage />} />
            <Route path="/link-cards" element={<CardLinkingPage />} />
            <Route path="/projection" element={<ProjectionPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
